import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderVpsComponent from "../../../components/Customer/cards/OrderVpsComponent";

const OrderVpsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderVpsComponent
        productId={ params.productId }
        billcycle={ params.billcycle }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectBack={ () => redirectBack() }
    />;
}

export default OrderVpsPage;